'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { Modal, type ModalProps } from '../modal.tsx'
import { FormModalAcceptButton } from './form-modal-accept-button.tsx'
import { FormModalBody } from './form-modal-body.tsx'
import { FormModalCancelButton } from './form-modal-cancel-button.tsx'
import { FormModalFooter } from './form-modal-footer.tsx'
import { FormModalForm } from './form-modal-form.tsx'
import { FormModalHeader } from './form-modal-header.tsx'

export type FormModalProps = Readonly<ModalProps & { className?: string }>

export const FormModalComponent = ({
  children,
  className,
  ...modalProps
}: FormModalProps) => {
  return (
    <Modal {...modalProps}>
      <Modal.Dialog className={cn('w-160 flex flex-col gap-6 p-0', className)}>
        {children}
      </Modal.Dialog>
    </Modal>
  )
}

const FormModalNamespace = Object.assign(FormModalComponent, {
  AcceptButton: FormModalAcceptButton,
  Body: FormModalBody,
  CancelButton: FormModalCancelButton,
  Footer: FormModalFooter,
  Form: FormModalForm,
  Header: FormModalHeader,
})

export { FormModalNamespace as FormModal }
